import store from "@/store";

function getPrice(plan_id) {
  const product = store.state.products.find(p => p.id === plan_id);
  if (!product) return null;
  return product.amount / 100;
}

export function trackPurchase(trackingID, plan, quantity, total) {
  let price = getPrice(plan);
  let dataLayer = (window.dataLayer = window.dataLayer || []);
  dataLayer.push({
    transactionId: trackingID,
    transactionAffiliation: "",
    transactionTotal: total / 100,
    transactionTax: 0,
    transactionShipping: 0,
    transactionProducts: [
      {
        sku: plan,
        name: plan,
        category: "Nanome Software",
        price: price,
        quantity: quantity
      }
    ],
    event: "Purchase Complete",
    target: "Conversion",
    action: "Purchase License",
    "target-properties": plan,
    value: quantity
  });
}
